interface UrlParameters {
  path?: string[];
  query?: Record<string, string | number | boolean | undefined>;
}

export function createPathQueryString(parameters: UrlParameters): string {
  let pathQueryString = '';

  if (parameters.path) {
    pathQueryString = `/${parameters.path.join('/')}`;
  }

  if (parameters.query) {
    const urlSearchParameters = new URLSearchParams();
    for (const [key, value] of Object.entries(parameters.query)) {
      if (value !== undefined) {
        urlSearchParameters.append(key, String(value));
      }
    }

    pathQueryString += urlSearchParameters.toString().length > 0 ? `?${urlSearchParameters.toString()}` : '';
  }
  return pathQueryString;
}
